<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF ALLIED HEALTH SCIENCES</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Naturopathy & Yoga Sciences</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                            <th class="time">Diploma</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Bachelor of Naturopathy and Yogic Sciences</td>
                            <td class="time">Diploma in Naturopathy and Yogic Science</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <tbody>
                        <tr>
                            <td class="time bg-secondary text-white">COURSE</td>
                            <td class="time">: B.N.Y.S (Bachelor of Naturopathy and Yogic Sciences)</td>
                        </tr>
                        <tr>
                            <td class="time bg-secondary text-white">DURATION</td>
                            <td class="time">: 4.1/2 year + 1 year Compulsory rotatory Internship</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="row">
                    <div class="col-md-6 col-lg-6 col-sm-12">
                        <div class="event-schedule-table table-responsive">
                            <table class="table">
                                <tbody>
                                <tr>
                                    <td class="time bg-secondary text-white">BNYS SUBJECTS</td>
                                    <td class="time"></td>
                                </tr>
                                <tr>
                                    <td class="time">1st Year</td>
                                    <td class="time">
                                        Anatomy, Physiology, Biochemistry, Philosophy of Naturopathy, Principles of
                                        Yoga,
                                        Sanskrit
                                    </td>
                                </tr>
                                <tr>
                                    <td class="time">2nd Year</td>
                                    <td class="time">
                                        Pathology, Microbiology, Community medicine, Yoga philosophy, Chromo magneto,
                                        Basic
                                        Pharmacology, Forensic Medicine & toxicology
                                    </td>
                                </tr>
                                <tr>
                                    <td class="time">3rd Year</td>
                                    <td class="time">
                                        Modern diagnosis, Acupuncture, Manipulative therapy, Nutrition & Medicinal
                                        Herbs,
                                        Modern Medical Diagnosis, Naturopathy diagnosis, Yoga application
                                    </td>
                                </tr>
                                <tr>
                                    <td class="time">4th Year</td>
                                    <td class="time">
                                        Hydrotherapy, Yoga Therapy, Fasting, , Physical Medicine and Rehabilitation,
                                        OBG,
                                        Basic Psychiatry and Psychology, Hospital management, Clinical Naturopathy
                                    </td>
                                </tr>
                                <tr>
                                    <td class="time">Does University have State permission (HP PERC) to run BNYS?</td>
                                    <td class="time">
                                        Yes
                                    </td>
                                </tr>
                                <tr>
                                    <td class="time">
                                        Is NEET mandatory for BNYS
                                    </td>
                                    <td class="time">
                                        No
                                    </td>
                                </tr>
                                <tr>
                                    <td class="time">Is BNYS a Doctor degree.</td>
                                    <td class="time">
                                        Yes
                                    </td>
                                </tr>
                                <tr>
                                    <td class="time">Do BNYS graduates become Govt. registered medical doctor?</td>
                                    <td class="time">
                                        Yes
                                    </td>
                                </tr>
                                <tr>
                                    <td class="time">Are Govt. scholarship schemes are applicable for BNYS?</td>
                                    <td class="time">
                                        Yes
                                    </td>
                                </tr>
                                <tr>
                                    <td class="time">Is education loan is available from bank for BNYS course?</td>
                                    <td class="time">
                                        Yes
                                    </td>
                                </tr>
                                <tr>
                                    <td class="time">Is hostel & food facility available for boys and girls at
                                        university
                                        campus?
                                    </td>
                                    <td class="time">
                                        Yes
                                    </td>
                                </tr>
                                <tr>
                                    <td class="time">Are there extracurricular and sports facility available at
                                        university?
                                    </td>
                                    <td class="time">
                                        Yes
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-12">
                        <tr>
                            <td class="time bg-secondary text-white text-center">BNYS</td>
                        </tr>
                        <tr>
                            <td>
                                <p>Bachelor of Naturopathy & Yogic Sciences** is a five-and-a-half-year medical academic
                                    program, including a one-year compulsory rotatory internship. It is recognized by
                                    the
                                    Ministry of AYUSH, Government of India, and is also included in the UGC Gazette.</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p><b>1. Major therapies in taught in BNYS:</b></p>
                                <p>Yoga, Diet & Nutrition, Hydrotherapy, Acupuncture, Manipulative therapy, Chromo
                                    therapy,
                                    Magnet therapy, Mud therapy, Fasting therapy, Panchakarma, Herbology, Chiropractice,
                                    Emergency and First Aid, Skin care, Maternal and Baby care, Physiotherapy,
                                    Reflexology,
                                    Reiki & Pranic haling, etc.</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p><b>2. Major diseases treated/managed by BNYS graduate:</b></p>
                                <p>Diabetes Mellitus, High Blood Pressure, Obesity, Bronchial Asthma, Arthritis,
                                    Digestive
                                    Problems, Migraine, Insomnia, Cervical, Sciatica, Back Pain, Knee Pain, Female
                                    Problems,
                                    PCOD, Skin Diseases, Hypothyroidism, etc.</p>
                            </td>
                        </tr>
                    </div>
                </div>
            </div>
            <div class="col-md-12 col-lg-12 col-sm-12">
                <table class="table table-responsive table-bordered text-center">
                    <tbody>
                    <tr>
                        <th class="MGth" style="background-color:#e67e22;color:white">AREA</th>
                        <th class="MGth" style="background-color:#e67e22;color:white">POSITION</th>
                        <th class="MGth" style="background-color:#e67e22;color:white">ROLE</th>
                    </tr>
                    <tr>
                        <td class="MGtd MGborder">Naturopathy Hospitals</td>
                        <td class="MGborder">Medical Officer, Chief Medical Officer, Medical Director</td>
                        <td class="MGborder">Patient counseling and treatment</td>
                    </tr>
                    <tr>
                        <td class="MGtd MGborder">Govt. &amp; Private Hospitals</td>
                        <td class="MGborder">Nutritionist, Yoga Teacher, Medical Officer</td>
                        <td>Patient naturopathy counseling, Diet and Nutrition counseling, Yoga therapy</td>
                    </tr>
                    <tr>
                        <td class="MGtd MGborder">Academics</td>
                        <td class="MGborder">Assistant / Associate Professor, Professor</td>
                        <td class="MGborder">Teaching related activities</td>
                    </tr>
                    <tr>
                        <td class="MGtd MGborder">Medical Research Projects</td>
                        <td class="MGborder">Research Officer, Project Officer, Junior / Senior Research Fellow</td>
                        <td class="MGborder">Research related activities</td>
                    </tr>
                    <tr>
                        <td class="MGtd MGborder">Fitness and Yoga</td>
                        <td class="MGborder">Personal Trainer, Yoga Expert, Gym Trainer, Dietitian, Team Leader</td>
                        <td class="MGborder">Individual fitness &amp; diet training and counseling</td>
                    </tr>
                    <tr>
                        <td class="MGtd MGborder">Yoga Centers</td>
                        <td class="MGborder">Yoga Teacher, Yoga Doctor</td>
                        <td class="MGborder">Training Yoga Students, Treating Patients through Yoga</td>
                    </tr>
                    <tr>
                        <td class="MGtd MGborder">Entrepreneur</td>
                        <td class="MGborder">Chief Executive Officer; Yoga centre, Meditation Center, Pain Clinic,
                            Cosmetology, Health supplement, Detox Centers
                        </td>
                        <td class="MGborder">Overall Operations and Management</td>
                    </tr>
                    <tr>
                        <td class="MGtd MGborder">Wellness Resorts / Health Retreats</td>
                        <td class="MGborder">Wellness Coach, Holistic Health Coach, Wellness director</td>
                        <td class="MGborder">Health Counseling, Leadership, Yoga Training</td>
                    </tr>
                    <tr>
                        <td class="MGtd MGborder">Fitness Centers</td>
                        <td class="MGborder">Fitness Expert</td>
                        <td class="MGborder">Gym &amp; Fitness Training</td>
                    </tr>
                    <tr>
                        <td class="MGtd MGborder">Hospital Administrator</td>
                        <td class="MGborder">Administrative Officer</td>
                        <td class="MGborder">Hospital management</td>
                    </tr>
                    <tr>
                        <td class="MGtd MGborder">Community Health Officer</td>
                        <td class="MGborder">Community Medical Officer</td>
                        <td class="MGborder">Screening, Surveillance and implementation activities in community</td>
                    </tr>
                    <tr>
                        <td class="MGtd MGborder">Government Hospitals</td>
                        <td class="MGborder">Medical officer, Ayush doctor, Mental Health Counselor</td>
                        <td class="MGborder">Patient Counseling and Treatment, Supervision of Government Sponsored
                            Programs
                        </td>
                    </tr>
                    <tr>
                        <td class="MGtd MGborder">Govt. Health Project</td>
                        <td class="MGborder">Project officer</td>
                        <td class="MGborder">Project management, Data collection, analysis and reporting</td>
                    </tr>
                    <tr>
                        <td class="MGtd MGborder">Community Health</td>
                        <td class="MGborder">Health Educators</td>
                        <td class="MGborder">Health awareness program and workshops in community</td>
                    </tr>
                    <tr>
                        <td class="MGtd MGborder">Rehabilitation Centers</td>
                        <td class="MGborder">Post Surgery, Post Stroke, Recovering from prolonged disease</td>
                        <td class="MGborder">Assessment of patient improvement, Diet and Physical therapy</td>
                    </tr>
                    <tr>
                        <td class="MGtd MGborder">Cruise Ship</td>
                        <td class="MGborder">Acupuncturist, Yoga instructor</td>
                        <td class="MGborder">Acupuncture Treatments and Yoga Sessions</td>
                    </tr>
                    <tr>
                        <td class="MGtd MGborder">Corporate</td>
                        <td class="MGborder">Wellness Consultant, Program officer</td>
                        <td class="MGborder">Health assessment &amp; counseling of Employee</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <hr class="border-dashed border-2"/>

        <div class="row">

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Naturopathy and Yogic Sciences</b>
                    – Bachelor of Naturopathy & Yogic Sciences offered by ARNI School of Allied Health Sciences is a
                    five-and-a-half-year medical academic program, including a one-year compulsory rotatory internship.
                    It is recognized by the Ministry of AYUSH, Government of India, and is also included in the UGC
                    Gazette.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">First Year
                </b></p>
                <ul>
                    <li> Anatomy</li>
                    <li> Physiology</li>
                    <li> Biochemistry</li>
                    <li> Philosophy of Naturopathy</li>
                    <li> Principles of Yoga</li>
                    <li> Sanskrit</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Second Year
                </b></p>
                <ul>
                    <li> Pathology</li>
                    <li> Microbiology</li>
                    <li> Community Medicine</li>
                    <li> Yoga Philosophy</li>
                    <li> Chromo Magneto</li>
                    <li> Basic Pharmacology</li>
                    <li> Forensic Medicine & Toxicology</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Third Year
                </b></p>
                <ul>
                    <li> Modern Diagnosis</li>
                    <li> Acupuncture</li>
                    <li> Manipulative Therapy</li>
                    <li> Nutrition & Medicinal Herbs</li>
                    <li> Modern Medical Diagnosis</li>
                    <li> Naturopathy Diagnosis</li>
                    <li> Yoga application</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Fourth Year
                </b></p>
                <ul>
                    <li> Hydrotherapy</li>
                    <li> Yoga Therapy</li>
                    <li> Fasting</li>
                    <li> Physical Medicine and Rehabilitation</li>
                    <li> OBG</li>
                    <li> Basic Psychiatry and Psychology</li>
                    <li> Hospital management</li>
                    <li> Clinical Naturopathy</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Fifth Year
                </b></p>
                <ul>
                    <li>Internship</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Diploma in Naturopathy and Yogic Science</b>
                    – The Diploma in Naturopathy and Yogic Sciences (DNYS) offered by ARNI School of Allied Health
                    Sciences is a 2-year paramedical course designed to train individuals as Naturopathy Therapists.
                    Unlike doctors, these therapists do not diagnose or prescribe, but they play a vital role in
                    providing treatments based on natural healing principles. This course equips students with the
                    knowledge and skills to assist in delivering naturopathic treatments, which focus on non-invasive
                    methods such as diet, herbal remedies, yoga, and other natural therapies.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1
                </b></p>
                <ul>
                    <li> Foundation of Naturopathy, Health, and Nutrition</li>
                    <li> Fundamental Anatomy of the Human Body</li>
                    <li> Basic Philosophy and History of Natural Cure</li>
                    <li> Nutrition, Hygiene and Public Health</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2
                </b></p>
                <ul>
                    <li> Disease and Treatment by Naturopathy</li>
                    <li> Method of Nature Care</li>
                    <li> Yoga Therapy</li>
                    <li> Different Naturopathy systems</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3
                </b></p>
                <ul>
                    <li> Anatomy and Physiology</li>
                    <li> Hatha Yoga</li>
                    <li> Sanskrit</li>
                    <li> Therapy Acupressure</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4
                </b></p>
                <ul>
                    <li> Yoga Diet</li>
                    <li> Advanced Yoga Techniques</li>
                    <li> Yoga Practice</li>
                </ul>
            </div>

        </div>

    </div>
</section>
